export default __webpack_public_path__ + "static/media/placeholder-profile-image.57cf9335.png";